import React from 'react';
import MainMenu from '../../components/menu/MainMenu';
import { Card, Col, Row, Container, Jumbotron } from 'react-bootstrap';
import ManualCard from './ManualCard';
import './Manual.css';
import custProfilePdf from "../../resources/pdf/custProfile.pdf"
import merchantProfilePdf from "../../resources/pdf/merchantProfile.pdf"
import reportPdf from "../../resources/pdf/report.pdf"
import userProfilePdf from "../../resources/pdf/userProfile.pdf"
import { faStoreAlt, faChartBar, faUserCog, faUsers } from '@fortawesome/free-solid-svg-icons';
const Manual = ({role}) => {
        const manualList = [
            { icon: faStoreAlt, file: merchantProfilePdf, download:"PGW User Manual - Merchant - Merchant Profile", title: "MERCHANT PROFILE", description: "Allows you to view your company profile that being used for integration between you and SCB Payment Gateway."}, 
            { icon: faUsers, file: custProfilePdf, download:"PGW User Manual - Merchant - Customer Profile", title: "CUSTOMER PROFILE", description: "Allows you to view your customer profile who already registered for SCB direct debit service for your company."}, 
            { icon: faUserCog, file: userProfilePdf, download:"PGW User Manual - Merchant - User Profile", title: "USER", description: "Allows you to manage authorization for other users in the same company who will have no privilege to further create any other users."},           
            { icon: faChartBar, file: reportPdf, download:"PGW User Manual - Merchant - Report", title: "REPORT​", description: "Allows you to view online reports. Some are also available to download in .csv or .pdf format."}, 
        ]

        const manualCardDeck=manualList.map((manual, i) => {
            return <Col className="my-3" sm={4} key={i}>{<ManualCard {...manual} />}</Col>;
        });

        return (
            <React.Fragment>
                <Card className="shadow mt-2 mx-auto mb-70px card-width-1280">
                    <Card.Body className="p-0 bg-grey">
                        <MainMenu mainMenu={"manual"} subMenu={null} role={role}/>
                        <Jumbotron fluid className="bg-scb-gradient text-light text-center">
                            <h3 className="mb-4">USER MANUAL</h3>
                            <p>
                            Welcome to SCB Payment Gateway Admin Portal Online Documentation. Check out the topics you want to know.
                            </p>
                            <p className="medium font-italic">
                            Access to admin portal is managed by your organization. Contact your admin for more information.
                            </p>
                        </Jumbotron>     
                        <Container>
                            <Row>{manualCardDeck}</Row>                                                                                                     
                        </Container>
                    </Card.Body>
                </Card>     
            </React.Fragment>
        );
}
export default Manual